import * as Sentry from "@sentry/react";

// Sentry (GlitchTip) yalnızca production build'de (npm run build) ve DSN tanımlıysa başlatılır.
// medmasraf CRA (Create React App) olduğu için Vite (import.meta.env) yerine process.env
// kullanılır. Local geliştirmede (npm start) NODE_ENV=development olduğundan aktifleşmez.
// medmasraf, react-router-dom v6 (beta) kullandığı için referans projedeki v7 routing
// instrumentation yerine yalnızca browserTracingIntegration kullanılır.
export const initSentry = () => {
  if (
    process.env.REACT_APP_ENV?.toLocaleLowerCase() === "production" &&
    !!process.env.REACT_APP_SENTRY_DSN
  ) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration()],
      sampleRate: 1.0,
      tracePropagationTargets: [],
      tracesSampleRate: 1.0,
      beforeSend(event, hint) {
        const error = hint?.originalException;

        const status = error?.response?.status || error?.status || error?.originalError?.status;

        // Kullanıcı kaynaklı / beklenen hataları (validation, auth) gönderme.
        if ([400, 401, 403].includes(status)) {
          return null;
        }

        return event;
      },
    });
  }
};
